// for the exhibit gallery pages. When an image is clicked, have a 
//  modal popup with a slider inside
function gallerySlider() {
  jQuery('.exhibit_gallery_item').on('click', function(e) {
    e.preventDefault();
    var dataCount = jQuery(this).attr('data-count');
    //jump to the slider of the image clicked
    jQuery('.slick__slider').slick('slickGoTo', parseInt(dataCount) - 1);
    // popup the modal
    jQuery('.slick-modal').modal('show').trigger('resize');
 });
};
export { gallerySlider }
